import {ViewerContext} from '@wix/ecom-platform-storefront-common';
import {EcommerceSettings} from '@wix/wixstores-client-storefront-sdk';
import {SPECS} from '../specs';

export class EcommerceSettingsModel {
  public hasValidationsInCart: boolean;
  public hasAdditionalFees: boolean;
  public taxIncludedInItemPrices: boolean;
  public canBusinessShip: boolean;
  public isPremium: boolean;

  constructor(params: EcommerceSettingsModel) {
    this.hasValidationsInCart = params.hasValidationsInCart;
    this.hasAdditionalFees = params.hasAdditionalFees;
    this.taxIncludedInItemPrices = params.taxIncludedInItemPrices;
    this.canBusinessShip = params.canBusinessShip;
    this.isPremium = params.isPremium;
  }

  public static fromEcommerceSettings(
    ecommerceSettings: EcommerceSettings,
    {viewerContext}: {viewerContext: ViewerContext}
  ) {
    if (!ecommerceSettings) {
      return new EcommerceSettingsModel({
        hasValidationsInCart: true,
        hasAdditionalFees: true,
        taxIncludedInItemPrices: false,
        isPremium: true,
        canBusinessShip: true,
      });
    }

    return new EcommerceSettingsModel({
      hasValidationsInCart: ecommerceSettings.hasValidationsInCart,
      hasAdditionalFees: ecommerceSettings.hasAdditionalFees,
      taxIncludedInItemPrices: ecommerceSettings.tax.taxIncludedInItemPrices,
      canBusinessShip: viewerContext.isExperimentEnabled(SPECS.UseEcommerceSettingsDeliveryCountries)
        ? ecommerceSettings.delivery.countries?.length > 0 || !!ecommerceSettings.delivery.restOfWorld
        : ecommerceSettings.delivery?.canBusinessShip,
      isPremium: ecommerceSettings.isPremium,
    });
  }
}
